
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderGiftCardsGrid extends Serenity.EntityGrid<OrderGiftCardsRow, any> {
        protected getColumnsKey() { return OrderGiftCardsColumns.columnsKey; }
        protected getDialogType() { return OrderGiftCardsDialog; }
        protected getIdProperty() { return OrderGiftCardsRow.idProperty; }
        protected getInsertPermission() { return OrderGiftCardsRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderGiftCardsRow.localTextPrefix; }
        protected getService() { return OrderGiftCardsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}